import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoEsquemasEsquemaImpuestosComponent {
  data
  onChange

  agregar (impuesto) {
    if (impuesto) {
      impuesto.tipoFactorId = 1
      this.data.impuestos = [...this.data.impuestos, impuesto]
      this.onChange({$event: {detail: this.data.impuestos}})
    }
    this.agregando = false
  }

  eliminar (impuesto) {
    this.data.impuestos = this.data.impuestos.filter((item) => item !== impuesto)
    this.onChange({$event: {detail: this.data.impuestos}})
  }
}

module.component('fanProyectoEsquemasEsquemaImpuestos', {
  controller: FanProyectoEsquemasEsquemaImpuestosComponent,
  template,
  bindings: {
    data: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/esquemas/esquema/impuestos/component.js